import * as v from "valibot";

import { rpcContract } from "../rpc";

export const getFeedbackRpcContract = rpcContract({
  name: "getFeedback",
  paramsSchema: v.object({
    feedbackId: v.string(),
  }),
  resultSchema: v.object({
    feedback: v.object({
      id: v.string(),
      authentication_user_id: v.nullable(v.string()),
      comment: v.nullable(v.string()),
      is_positive: v.nullable(v.boolean()),
      page_url: v.nullable(v.string()),
      user_agent: v.nullable(v.string()),
      ip_address: v.nullable(v.string()),
      published_at: v.string(),
      user: v.optional(
        v.object({
          id: v.string(),
          email: v.string(),
          name: v.string(),
        }),
      ),
    }),
  }),
});

export type GetFeedbackParams = v.InferOutput<(typeof getFeedbackRpcContract)["paramsSchema"]>;
export type GetFeedbackResult = v.InferOutput<(typeof getFeedbackRpcContract)["resultSchema"]>;
